// extracted by mini-css-extract-plugin
module.exports = {"ModalPage":"ModalPage_ModalPage__BjvPy"};